import debug from 'bows';
import selectr from '../_selectr';

const log = debug('issue');

class Issue {
	constructor(opts) {
		this.opts = opts;

		this.nav = selectr( document.querySelector( '.issue__navigation select' ) );
		this.nav.on( 'selectr.change', (option) => {
			if ( option.value ) {
				window.location.href = option.value;
			}
		});

		log(this);
	}
}

export default function( opts = {} ) {
	return new Issue(opts);
}
